module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline-title"
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1"
    }
  }, [_c('rect', {
    attrs: {
      "x": "9",
      "y": "0",
      "width": "2",
      "height": "100%"
    }
  })]), _vm._v(" "), _c('h2', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69c542a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timeline/TimelineTitle.vue
// module id = 299
// module chunks = 1